const PORTAL_HANDOFF_PARAM = 'portal_handoff';

export const getPortalJourneyRequest = (locationLike = window.location) => {
  const params = new URLSearchParams(locationLike.search || '');
  const token = (params.get(PORTAL_HANDOFF_PARAM) || '').trim();
  const portalJourney = params.get('journey') === 'portal' || Boolean(token);
  return { portalJourney, token };
};

export const validatePortalHandoff = (payload) => {
  const sessionId = String(payload?.session_id || '').trim();
  const name = String(payload?.user?.name || '').trim();
  const email = String(payload?.user?.email || '').trim().toLowerCase();

  if (
    payload?.success !== true ||
    payload?.portal_journey !== true ||
    sessionId.length < 8 ||
    name.length < 2 ||
    !email.includes('@')
  ) {
    throw new Error('invalid_portal_handoff');
  }

  return {
    sessionId,
    user: { name, email },
  };
};

export const removePortalHandoffToken = (locationLike = window.location) => {
  const url = new URL(locationLike.href);
  url.searchParams.delete(PORTAL_HANDOFF_PARAM);
  url.searchParams.set('journey', 'portal');
  return `${url.pathname}${url.search}${url.hash}`;
};
